window.outputTimes = [];
window.outputCounters = [];
window.copyTimes = [];
window.triggerInputs = {};
export default superclass => class extends superclass  {
    runFlow(
        time,
        stepNumber,
        actualStepNumber,
        root=this.inputNode,
        inputTriggers=this.triggers,
        adjacencyLists=this.adjacencyLists,
        useCache=true)
    {
        window.triggerInputs[time] = 0;
        let finalTriggers = [];
        let q = [];
        q.push(root);

        let ctr=0;
        while (q.length > 0) {
            let v = q.shift();
            ctr++;
            let start = new Date().getTime();
            let triggers = v.output ?
                v.output(time, stepNumber, actualStepNumber)  :
                [... inputTriggers];
            let end = new Date().getTime();
            window.outputTimes.push({time: end-start, name: v.name});

            if (adjacencyLists[v.id] === undefined) {
                continue;
            }

            for (let edge of adjacencyLists[v.id]) {
                let w = edge.effect;
                let p  = edge.probability;
                edge.triggerCount = 0;

                if (Math.random() >= p / 100.0) {
                    continue;
                }

                // todo: make sure infinite loop doesn't happen
                if (w.input) {
                    let c_start = new Date().getTime();
                    triggers
                        .filter(t =>
                                (t.outputNumber === undefined && edge.outputNumber === 0) ||
                                t.outputNumber === edge.outputNumber)
                        .forEach(
                            t => {
                                // this probably is bad to be passing this shit through
                                // w/o copying, however this does keep us from having
                                // to use mad stepdatas
                                edge.triggerCount++;
                                if (adjacencyLists[v.id].length > 1) {
                                    t = this.copyTrigger(t, useCache);
                                }
                                window.triggerInputs[time]++;
                                w.input(t, t.time === undefined);
                            }); 
                    let c_end = new Date().getTime();
                    window.copyTimes.push(c_end - c_start);
                } else {
                    // it's the last triggers
                    let trigs = triggers.filter(
                        trig =>
                            (trig.outputNumber === undefined && edge.outputNumber === 0) ||
                            trig.outputNumber === edge.outputNumber);
                    edge.triggerCountc+= trigs.length;
                    finalTriggers = [... finalTriggers, ... trigs];
                }
                w.parent = v;

                // TODO: determine whether checking if we've already added w
                // (which was fucking up the Gen. Chord Effect) will mess up
                // the Midi Effect Rack.
                if (!q.includes(w)) {
                    q.push(w);
                }
            }
        }

        window.outputCounters.push(ctr);
        return finalTriggers;
 
    }
}
